const images = require.context('../assets/styles', false, /\.(png|jpg|jpeg|gif|svg)$/);
const imageFiles = images
  .keys()
  .map(file => {
    const path = images(file);
    const match = path.match(/\/media\/(\d+)\./); // Extract number before the first dot
    const num = match ? parseInt(match[1], 10) : Infinity; // Convert to integer
    return { path, num };
  })
  .sort((a, b) => a.num - b.num) // Sort numerically
  .map(item => item.path);
const styleOptions = [
  { value: 'Fooocus V2', label: '# Fooocus V2', link: imageFiles[0] },
  { value: 'Fooocus V2', label: '# Fooocus V2', link: imageFiles[0] },
  { value: 'Fooocus V2', label: '# Fooocus V2', link: imageFiles[0] },
  { value: 'Fooocus Enhance', label: '# Fooocus Enhance', link: imageFiles[1] },
  { value: 'Fooocus Sharp', label: '# Fooocus Sharp', link: imageFiles[2] },
  { value: 'Fooocus Masterpiece', label: '# Fooocus Masterpiece', link: imageFiles[3] },
  { value: 'Fooocus Cinematic', label: '# Fooocus Cinematic', link: imageFiles[4] },
  { value: 'SAI Anime', label: '# SAI Anime', link: imageFiles[5] },
  { value: 'SAI Comic Book', label: '# SAI Comic Book', link: imageFiles[6] },
  { value: 'SAI Line Art', label: '# SAI Line Art', link: imageFiles[7] },
  { value: 'SAI Enhance', label: '# SAI Enhance', link: imageFiles[8] },
  { value: 'SAI Neonpunk', label: '# SAI Neonpunk', link: imageFiles[9] },
  { value: 'MRE Dark Dream', label: '# MRE Dark Dream', link: imageFiles[10] },
  { value: 'MRE Anime', label: '# MRE Anime', link: imageFiles[11] },
  { value: 'MRE Comic', label: '# MRE Comic', link: imageFiles[12] },
  { value: 'Artstyle Abstract Expressionism', label: '# Artstyle Abstract Expressionism', link: imageFiles[13] },
  { value: 'Futuristic Biomechanical', label: '# Futuristic Biomechanical', link: imageFiles[14] },
  { value: 'Game Bubble Bobble', label: '# Game Bubble Bobble', link: imageFiles[15] },
  { value: 'Papercraft Flat Papercut', label: '# Papercraft Flat Papercut', link: imageFiles[16] },
  { value: 'Adorable 3D Character', label: '# Adorable 3D Character', link: imageFiles[17] },
  { value: 'Bauhaus Style Poster', label: '# Bauhaus Style Poster', link: imageFiles[18] },
  { value: 'Blueprint Schematic Drawing', label: '# Blueprint Schematic Drawing', link: imageFiles[19] },
  { value: 'Flat 2d Art', label: '# Flat 2d Art', link: imageFiles[20] },
  { value: 'Pencil Sketch Drawing', label: '# Pencil Sketch Drawing', link: imageFiles[21] }
];

export default styleOptions;